import config from "./config";
var axios = config();

export default {
  // get
  // getUsers() {
  //   return axios.get("/api/Users");
  // },

  getUsers(filters) {
    var filter = "";

    if (filters.search) {
      filter += "&search=" + filters.search;
    }
    if (filters.page) {
      filter += "&pageNumber=" + filters.page;
    }
    if (filters.pageSize) {
      filter += "&pageSize=" + filters.pageSize;
    }

    if (filters.sortBy) {
      filter += "&sortBy=" + filters.sortBy + "&sortDesc=" + filters.sortDesc;
    }

    _.forEach(_.keys(filters), key => {
      if (filters[key]) {
        filter += "&" + key + "=" + filters[key];
      }
    });

    return axios.get("/api/Users?" + filter);
  },

  getUser(asuriteId) {
    return axios.get("/api/Users/GetUser/" + asuriteId);
  },

  getRoles() {
    return axios.get("/api/Users/GetRoles");
  },

  getColleges() {
    return axios.get("/api/Users/GetColleges");
  },

  getUserExists(asuriteId) {
    return axios.get("/api/Users/GetUserExists/" + asuriteId);
  },

  getLDAP(search) {
    return axios.get("/api/Users/FindLDAP?search=" + search);
  },

  // post
  createUser(user) {
    return axios.post("/api/Users/CreateUser", user);
  },

  // put
  updateUser(user) {
    return axios.put("/api/Users/UpdateUser", user);
  }
};
